@if (seeAll){
<div class="w-full h-full bg-white rounded-md border border-gray-300 text-black text-opacity-90 font-bold"
  (mouseenter)="hovered = true" (mouseleave)="hovered = false">
  <div class="w-full h-full overflow-hidden flex justify-center items-center py-20">
    <a [routerLink]="url" [state]="state" (click)="itemSelected()" class="h-full text-2xl flex items-center hover:underline line-clamp-3">{{title}}</a>
  </div>
  <ng-container *ngTemplateOutlet="footerTpl"></ng-container>
  <ng-content></ng-content>
</div>
}
@else {
<div class="w-full h-full bg-white rounded-md border border-gray-300 text-black text-opacity-90"
  (mouseenter)="hovered = true" (mouseleave)="hovered = false">
  <div [ngClass]="{'min-h-56': type === 'portal'}" class="h-[45%] md:h-[58%] w-full overflow-y-hidden relative rounded-t-md">
      <!-- <div class="py-1 px-5 bg-accent-400 text-white">
        Company Name
      </div> -->
      <cld-picture class="w-full"
        (click)="itemSelected()"
        [link]="url"
        [title]="title"
        [image]="image"
        [fallbackImage]="fallbackImage"
        [sourceMediaSizes]="imageSizes"
        [lazyload]="lazyLoadImage">
      </cld-picture>
      @if (hovered) {
        <div [@slideInOut]
          class="absolute bottom-0 left-0 w-full max-h-[60%] text-[18px] p-2 text-white bg-black bg-opacity-50">
          <a rel="nofollow" [routerLink]="url" (click)="itemSelected()" class="h-full w-full line-clamp-3">{{text}}</a>
        </div>
      } 
      <div *renderIf="{ roles: [UserRolesEnum.admin]}" class="absolute overflow-hidden top-0 right-0 flex items-center p-1 bg-black bg-opacity-50 text-white rounded-tr-md">
        <span class="font-semibold mr-1">{{views}}</span>
        <mat-icon svgIcon="core:visibility"></mat-icon>
        @if ( isAccessibleForFree !== undefined && type === 'portal' ) {
          <span class="ml-2 p-1" [ngClass]="isAccessibleForFree ? 'bg-green-500' : 'bg-accent-500'">{{ isAccessibleForFree ? 'Free' : 'Blocked' }}</span>
        }
      </div>

    </div>
    
    <div [ngClass]="{'h-[105px]': type != 'portal'}" class="w-full overflow-hidden flex items-end p-3">
      <a [routerLink]="url" [state]="state" (click)="itemSelected()" class="h-full text-2xl leading-[26px] hover:underline line-clamp-3">{{title}}</a>
    </div>
  <ng-container *ngTemplateOutlet="footerTpl"></ng-container>

  <ng-content></ng-content>
</div>
}